import LaravelEcho from '@/broadcast/LaravelEcho'
import OrderPriceRecalculated from '@/broadcast/listeners/OrderPriceRecalculated'
import OrderShouldBeReloaded from '@/broadcast/listeners/OrderShouldBeReloaded'
import OrderRewardsShouldBeReloaded from '@/broadcast/listeners/OrderRewardsShouldBeReloaded'
import DisplayRewardSelection from '@/broadcast/listeners/DisplayRewardSelection'
import PromotionsNotFound from '@/broadcast/listeners/PromotionsNotFound'
import OrderSubmitted from '@/broadcast/listeners/OrderSubmitted';
import OrderRepeated from '@/broadcast/listeners/OrderRepeated';

let echoInstance = null
let vueInstance = null

export default {
  namespaced: true,

  state: {
    available: false,
    ready: false,
    order_id: null,
    token: null,
  },

  getters: {
    available(state) {
      return state.available === true
    },

    ready(state) {
      return state.ready === true
    },

    orderId(state) {
      return state.order_id
    },

    token(state) {
      return state.token
    },
  },

  mutations: {
    setAvailable(state, value) {
      state.available = value
    },

    setReady(state, value) {
      state.ready = value
    },

    setConnectedTo(state, { id, token }) {
      state.order_id = id
      state.token = token
    },
  },

  actions: {
    init({ commit }, { settings, app }) {
      return new Promise((resolve, reject) => {
        if (!settings || !settings.app_key || !settings.options) {
          commit('setAvailable', false)

          return reject({ message: 'No Pusher settings' })
        }

        commit('setAvailable', true)

        vueInstance = app
        echoInstance = new LaravelEcho(settings.app_id, settings.app_key, settings.options)

        commit('setReady', true)

        return resolve(echoInstance)
      })
    },

    connect({ commit, getters }, { id, token }) {
      return new Promise((resolve, reject) => {
        if (!getters.available) {
          console.log('[Broadcast/connect] Websocket is not available to this store.')

          return reject({ message: 'Websocket is not available.' })
        } else if (!getters.ready) {
          console.error('[Broadcast/connect] Websocket is not yet ready.')

          return reject({ mesage: 'Websocket is not yet ready.' })
        } else if (getters.orderId === id) {
          console.log('[Broadcast/connect] Already connected to order.', { id })

          return reject({ mesage: 'Already connected to order.' })
        } else if (getters.orderId !== null) {
          echoInstance.getEcho().leave(`orders.${getters.orderId}.${getters.token}`)
        }

        echoInstance.getEcho()
          .channel(`orders.${id}.${token}`)
          .listen('.orders.price.recalculated', e => OrderPriceRecalculated(e, vueInstance))
          .listen('.orders.reload', e => OrderShouldBeReloaded(e, vueInstance))
          .listen('.orders.rewards.reload', e => OrderRewardsShouldBeReloaded(e, vueInstance))
          .listen('.orders.rewards.display_selection', e => DisplayRewardSelection(e, vueInstance))
          .listen('.orders.promotions.not_found', e => PromotionsNotFound(e, vueInstance))
          .listen('.orders.submitted', e => OrderSubmitted(e, vueInstance))
          .listen('.orders.repeated', e => OrderRepeated(e, vueInstance));

        commit('setConnectedTo', { id, token })

        console.log('[Broadcast/connect] Successfully subscribed to order updates.')

        return resolve()
      })
    },
  },
}
